export default __webpack_public_path__ + "static/media/unlike.46ded053.png";